// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { customerCardStyles } from "@insite/content-library/Components/CustomerCard";
import Edit from "@insite/mobius/Icons/Edit";
import { iconLinkCommonStyles, mergeWithCss, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

customerCardStyles.addressGridItem = {
    width: [12, 6, 6, 6, 6],
};

customerCardStyles.actionsGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        justify-content: flex-end;
    `,
};

customerCardStyles.actionsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;

        ${xScreen("lte", "xs")} {
            flex-direction: row;
            justify-content: space-between;
            height: auto;
            width: 100%;
        }
    `,
};

customerCardStyles.editLink = {
    ...mergeWithCss(iconLinkCommonStyles(Edit), {
        css: css`
            display: flex;
            justify-content: center;
            ${xScreen("lte", "xs")} {
                margin-top: 0;
            }
        `,
    }),
};
